import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $getNodeByKey,
  COMMAND_PRIORITY_CRITICAL,
  KEY_DOWN_COMMAND,
} from "lexical";
import { useEffect, useState } from "react";
import { cn } from "../../../../lib/utils";
import "./PlaceholderComponent.scss";
import { PlaceholderNode } from "./PlaceholderNode";

interface PlaceholderComponentProps {
  placeholder: string;
  value: string;
  nodeKey: string;
  mode: "add" | "edit";
  ref: React.RefObject<HTMLDivElement | null>;
}

export function PlaceholderComponent({
  placeholder,
  value,
  nodeKey,
  mode = "add",
  ref,
}: PlaceholderComponentProps) {
  const [editor] = useLexicalComposerContext();
  const [isFocused, setIsFocused] = useState(false);

  const handleInput = (e: React.FormEvent<HTMLSpanElement>) => {
    const newValue = e.currentTarget.textContent || "";

    editor.update(() => {
      const node = $getNodeByKey(nodeKey);
      if (node instanceof PlaceholderNode) {
        if (mode === "add") {
          node.setValue(newValue);
        } else {
          node.setPlaceholder(newValue);
        }
      }
    });
  };

  useEffect(() => {
    if (isFocused) {
      return editor.registerCommand(
        KEY_DOWN_COMMAND,
        () => true,
        COMMAND_PRIORITY_CRITICAL,
      );
    }
  }, [isFocused, editor]);

  return (
    <div
      ref={ref}
      className={cn(
        "single-line",
        "inline-block px-1 py-0.5 rounded bg-spectrum-blue-light/30 text-teal dark:bg-spectrum-blue-dark/30 dark:text-spectrum-blue-light transition-shadow relative",
        {
          "ring-0 bg-spectrum-blue-light/30 outline-0": isFocused,
          "text-teal dark:text-spectrum-blue-light font-bold": value.length > 0,
        },
      )}
      contentEditable
      suppressContentEditableWarning
      tabIndex={0}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onInput={handleInput}
      data-placeholder={placeholder || " "}
    />
  );
}
